import { render } from "./myOderDetails.vue?vue&type=template&id=f7548f04"
import script from "./myOderDetails.vue?vue&type=script&lang=js"
export * from "./myOderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__